import { trainingAPI } from "@api/TrainingAPI"
import TextArea from "antd/lib/input/TextArea"
import { IConfigureMetric, ISampleDataPointDataType } from "./consts"
import { useEffect, useMemo, useState } from "react"
import { Modal, Popover, Table, Tooltip, Typography, Tag } from "antd"
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux"

const { Text } = Typography;

const FormulaHelperModalContent = () => {
    const { misc: {supported_functions_info }} = useSelector(({ team }) => team);

    const columns: any[] = [
        {
            title: 'Function',
            dataIndex: 'key',
            key: 'key',
            width: 220,
            render: (_: any, record: any) => (<span style={{float: 'left'}} className="formula-input-kbd"><kbd>{record.key}</kbd></span>)
        },
        {
            title: 'Example',
            dataIndex: 'example',
            key: 'example',
            align: 'left',
            render: (_: any, record: any) => (<span style={{float: 'left'}} className="formula-input-kbd"><kbd>{record.example}</kbd></span>)
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: 'left',
            render: (_: any, record: any) => <span style={{float: 'left'}}><Text>{record.description}</Text></span>
        },
    ]

    return (
    <Table 
        dataSource={supported_functions_info || []}
        columns={columns}
        size="small"
        scroll={{ y: 360 }}
        pagination={false}
        style={{marginBottom : '20px', }}
    />)
}

export const FormulaInput = ({
    data,
    updateFieldData,
    idx,
    placeholder,
    sampleData
}: IFormulaInput) => {
    const [errorValidation, setErrorValidation] = useState<IMetricsFormulaValidation | undefined>(undefined)
    const [formulaHelperModalIsOpen, setFormulaHelperModalIsOpen] = useState<boolean>(false)
    const [localValue, setLocalValue] = useState<string>(data.extractionText ?? '')

    useEffect(() => {
        setLocalValue(data.extractionText ?? '')
    }, [data.extractionText])

    const dataModified = useMemo(() => {
        let answer: { [key: string]: any } = {}

        sampleData?.forEach((e) => {
            answer[e.field] = e.value
        })

        return answer
    }, [sampleData])

    return (
        <>
        <div style={{ position: "relative" }}>
            <TextArea
                rows={4}
                maxLength={500}
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onBlur={async (e) => {
                    updateFieldData({ extractionText: e.target.value }, idx)
                    const result: IMetricsFormulaValidation = await trainingAPI.validateFormula(e.target.value, dataModified)
                    setErrorValidation(result)
                }}
                placeholder={placeholder}
            />


            {errorValidation?.is_valid === true ?
                <>
                    <Text type="success">Valid{" "}
                        {(Object.entries(errorValidation?.detail?.fields || {}).length > 0 || errorValidation.detail?.result !== undefined) &&
                            <>[Result:{" "}
                                <Popover placement="right" trigger="hover" content={Object.entries(errorValidation?.detail?.fields || {}).length > 0 && <>{Object.entries(errorValidation?.detail?.fields || {})?.map(([key, val]) => <Text style={{ display: 'block' }}>{key}: {val}</Text>)}</>}>
                                    {Math.round((errorValidation?.detail?.result || 0) * 1000) / 1000}]
                                </Popover>
                            </>
                        }
                    </Text>
                </>
                :
                <Text type="danger">{errorValidation?.error_message}</Text>
            }

            <Tooltip 
                title={<Text>Click here to see a full list of functions you can use in your formula</Text>}
                placement="right"
                overlayStyle={{ maxWidth: '30vw' }}
                color="white"
                style={{borderRadius: '50px'}}
            >
                <ExclamationCircleOutlined 
                onClick={() => setFormulaHelperModalIsOpen(true)}
                style={{
                    color: '#bfbfbf',       
                    position: 'absolute',
                    top: '6px',
                    right: '6px',
                    fontSize: '15px',
                }}
                />
            </Tooltip>

            <Modal
                title="Supported Functions for Formula Inputs"
                footer={null}
                destroyOnHidden={true}
                open={formulaHelperModalIsOpen}
                onCancel={() => setFormulaHelperModalIsOpen(false)}
                width={1000}
            >
                <FormulaHelperModalContent />
            </Modal>

            </div>
        </>
    )
}

interface IMetricsFormulaValidation {
    is_valid: boolean
    error_message: string | undefined
    formula: string
    detail?: {
        result?: number;
        fields?: {
            [key: string]: number
        }
    }
}

interface IFormulaInput {
    data: IConfigureMetric,
    updateFieldData: (
        updates: Partial<IConfigureMetric>,
        index: number
    ) => void,
    idx: number,
    placeholder: string,
    sampleData?: ISampleDataPointDataType[]
}